module.exports = __webpack_public_path__ + "img/pr-32.84dc0a8d.png";